import { render, staticRenderFns } from "./risk-report-card.vue?vue&type=template&id=410a1e10"
import script from "./risk-report-card.vue?vue&type=script&lang=ts"
export * from "./risk-report-card.vue?vue&type=script&lang=ts"
import style0 from "./risk-report-card.vue?vue&type=style&index=0&id=410a1e10&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports